import React from "react";
import { useSwipeable } from "react-swipeable";
import { WorkOrderStatus } from "../../../types/workOrder";

interface SwaipeableModuleContainerProps {
    index: number;
    workOrderStatus: string;
    isActive: boolean;
    setShowIcons: React.Dispatch<React.SetStateAction<boolean[]>>;
    children: React.ReactNode;
}

const SwaipeableModuleContainer: React.FC<SwaipeableModuleContainerProps> = ({
    index,
    isActive,
    workOrderStatus,
    setShowIcons,
    children,
}) => {
    const swipeHandlers = useSwipeable({
        onSwipedLeft: (eventData) => {
            if (workOrderStatus === WorkOrderStatus.Completed) return;
            
            const target = eventData.event.target as HTMLElement;
            if (target.closest(".swipe-allowed")) {
                setShowIcons((prev) =>
                    prev.map((val, i) => (i === index ? true : val))
                );
            }
        },
        onSwipedRight: (eventData) => {
            if (workOrderStatus === WorkOrderStatus.Completed) return;
            
            const target = eventData.event.target as HTMLElement;
            if (target.closest(".swipe-allowed")) {
                setShowIcons((prev) =>
                    prev.map((val, i) => (i === index ? false : val))
                );
            }
        },
        preventScrollOnSwipe: false,
        trackMouse: false,
    });

    return (
        <div
            {...(workOrderStatus !== WorkOrderStatus.Completed ? swipeHandlers : {})}
            className={`relative transition-all duration-300 ${
                isActive ? "translate-x-[-50px]" : "translate-x-0"
            }`}
        >
            {children}
        </div>
    );
};

export default SwaipeableModuleContainer;
